import React, { Component } from 'react';

class FileErr extends Component {
  render() {
    return (
      <div className="result-group error-result">
        <div className="icon icon-result icon-error-result">
        </div>
        <div className="text-result">
          데이터를 불러올 수 없습니다.
        </div>
      </div>
    );
  }
}

export default FileErr;


// WEBPACK FOOTER //
// ./src/components/errorpage/FileErr.js